(function () {
  const routes = {
    '67582786797721': ['custom-lined-satin-kippah', 'custom-lined-navy-satin-kippah', '67599476949145'],
    '67590384124057': ['custom-lined-satin-kippah', 'custom-lined-navy-satin-kippah', '67599476981913'],
    '67590384156825': ['custom-lined-satin-kippah', 'custom-lined-navy-satin-kippah', '67599477014681'],
    '67582786830489': ['custom-lined-satin-kippah', 'custom-lined-black-satin-kippah', '67599477047449'],
    '67590384189593': ['custom-lined-satin-kippah', 'custom-lined-black-satin-kippah', '67599477080217'],
    '67590384222361': ['custom-lined-satin-kippah', 'custom-lined-black-satin-kippah', '67599477112985'],
    '67582787322009': ['blank-lined-satin-kippah', 'blank-lined-navy-satin-kippah', '67599477145753'],
    '67582787354777': ['blank-lined-satin-kippah', 'blank-lined-black-satin-kippah', '67599477178521'],
  };

  const pathMatch = window.location.pathname.match(
    /^(\/(?:[a-z]{2}(?:-[a-z]{2})?)?)?\/products\/(custom-lined-satin-kippah|blank-lined-satin-kippah)\/?$/i
  );
  if (!pathMatch) return;

  const sourceHandle = pathMatch[2].toLowerCase();
  const currentParams = new URLSearchParams(window.location.search);
  const route = routes[currentParams.get('variant')];
  if (!route || route[0] !== sourceHandle) return;

  const safeExactParams = new Set([
    'selling_plan',
    'preview_theme_id',
    'country',
    'currency',
    'locale',
    '_pos',
    '_sid',
    '_ss',
    'gclid',
    'dclid',
    'fbclid',
    'msclkid',
    'twclid',
  ]);
  const safeParams = new URLSearchParams();
  safeParams.set('variant', route[2]);

  for (const [key, value] of currentParams) {
    const normalizedKey = key.toLowerCase();
    const isSafeUtm = /^utm_(source|medium|campaign|term|content|id)$/.test(normalizedKey);
    if (normalizedKey !== 'variant' && (safeExactParams.has(normalizedKey) || isSafeUtm)) {
      safeParams.append(key, value);
    }
  }

  const localePrefix = pathMatch[1] || '';
  const targetPath = `${localePrefix}/products/${route[1]}`;
  window.location.replace(`${targetPath}?${safeParams.toString()}${window.location.hash}`);
})();
